<template>
  <div>
    <div class="container-fluid">
      <div class="row el-table__body JY-order-detail JY-order-detail-b">
        <div class="col-sm-6 col-md-6" style="border-right: 1px solid #dfdfdf;">
          <el-form class="el-form demo-table-expand el-form--label-left">
            <el-form-item label="起运日期">
              <span>{{good.ChuFaRiQi}}</span>
            </el-form-item>
            <el-form-item label="到达日期">
              <span>{{good.DaoDaRiQi}}</span>
            </el-form-item>
            <el-form-item label="有效期开始">
              <span>{{good.YouXiaoQiStart}}</span>
            </el-form-item>
            <el-form-item label="有效期结束">
              <span>{{good.YouXiaoQiEnd}}</span>
            </el-form-item>
            <el-form-item label="出发地">
              <span>{{good.ChuFaDi}}</span>
            </el-form-item>
            <el-form-item label="到达地">
              <span>{{good.DaoDaDi}}</span>
            </el-form-item>
            <el-form-item v-if="!hiddenInfo" label="出发详细地址">
              <span>{{good.ChuFaDiAddr}}</span>
            </el-form-item>
            <el-form-item v-if="!hiddenInfo" label="到达详细地址">
              <span>{{good.DaoDaDiAddr}}</span>
            </el-form-item>
            <el-form-item label="报价方式">
              <span>{{good.BaoJiaLeiXing=='0'?'按吨':'按车'}}</span>
            </el-form-item>
            <el-form-item label="货物类型">
              <span>{{good.GoodsType}}</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='0'" label="单包重量">
              <span>{{good.DanBaoZhongLiang}}公斤</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='0'" label="货物重量">
              <span>{{good.HuoWuZhongLiang}}吨</span>
            </el-form-item>
            <el-form-item label="码放方式">
              <span>{{good.MaFangFangShi==1?'平铺':'叠放'}}</span>
            </el-form-item>
            <el-form-item label="货物分类">
              <span>{{good.GoodsType}}</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='0'" label="包装方式">
              <span>{{good.PackingMethod}}</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='0'" label="长×宽×高 mm">
              <span>{{good.ZhuangZaiGuiGeLength||''}}×{{good.ZhuangZaiGuiGeWidth||''}}×{{good.ZhuangZaiGuiGeHeight||''}}（长×宽×高）</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='1'" label="最大件重量(公斤)" style="width:100%">
              <span>{{good.ZuiDaJianZhongLiang}}</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='1'&&good.ZuiDaJianLength" label="最大件尺寸 长×宽×高(cm)" style="width:100%">
              <span>{{good.ZuiDaJianLength +'×'+good.ZuiDaJianWidth+'×'+good.ZuiDaJianHeight}}</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='1'" label="单车件数" style="width:100%">
              <span>{{good.DanCheJianShu}}</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='1'" label="单车重量" style="width:100%">
              <span>{{good.DanCheZhongLiang}}</span>
            </el-form-item>
            <el-form-item label="货物描述" style="width:100%">
              <span>{{good.Description||'无'}}</span>
            </el-form-item>
            <el-form-item v-if="good.BaoJiaLeiXing=='0'" label="货物清单" style="width:100%; padding-bottom: 20px;">
              <el-tag v-for="item in good.SourceGoodsList" :key="item.ID">{{item.WuPinName}}({{item.WuPinNumber}}个)</el-tag>
            </el-form-item>
          </el-form>
        </div>

        <div class="col-sm-6 col-md-6">
          <el-form class="el-form demo-table-expand el-form--label-left" style="padding-left: 20px;">
            <p v-if="!hiddenInfo">
              <el-form-item label="发货人">
                <span>{{good.FaHuoRen}} {{good.FaHuoRenEmail||''}}</span>
              </el-form-item>
              <el-form-item label="发货人手机">
                <span>{{hiddenContract?"***********":good.FaHuoRenPhone}}</span>
              </el-form-item>
            </p>
            <p v-if="!hiddenInfo" style="margin-bottom: 20px;">
              <el-form-item label="收货人">
                <span>{{good.ShouHuoRen}} {{good.ShouHuoRenEmail||''}}</span>
              </el-form-item>
              <el-form-item label="收货人手机">
                <span>{{hiddenContract?"***********":good.ShouHuoRenPhone}}</span>
              </el-form-item>
            </p>
            <p v-if="!hiddenInfo" style="margin-bottom: 20px;">
              <el-form-item label="订单状态">
                <span><strong style="color: #df0024;">{{good.OrderStatus}}</strong></span>
              </el-form-item>
              <el-form-item label="货源号">
                <span>{{good.SourceGoodsNo}}</span>
              </el-form-item>
              <el-form-item label="订单号">
                <span>{{good.OrderInfo.OrderNo}}</span>
              </el-form-item>
              <el-form-item label="业务编号">
                <span>{{good.OrderInfo.YeWuDanHao}}</span>
              </el-form-item>
              <el-form-item v-if="good.BaoJiaLeiXing=='0'" label="计费重量方式">
                <span>{{good.JiFeiFangShi}}</span>
              </el-form-item>
              <el-form-item v-if="good.BaoJiaLeiXing=='0' && good.OrderInfo.JiFeiFangShi == '2'" label="亏吨扣款单价(元/吨)">
                <span>{{good.KuiDunKouKuan}}</span>
              </el-form-item>
              <el-form-item v-if="good.BaoJiaLeiXing=='0' && good.OrderInfo.JiFeiFangShi == '2'" label="允许亏损值(吨)">
                <span>{{good.YunXuKuiSun}}</span>
              </el-form-item>
              <el-form-item label="可以用同一类车运送此单">
                <span>{{good.OrderInfo.IsCarLimit=='0'?'否':'是'}}</span>
              </el-form-item>
            </p>
            <p v-if="!hiddenInfo" style="margin-bottom: 20px;">
            <el-form-item v-if="good.BaoJiaLeiXing==1" label="已分配车辆详情">
              <br />
              <div
                style="float:left; display: block; margin-bottom: 4px;margin-top: -28px;"
                v-for="car in good.FenPeiInfo"
                :key="car.ID"
              >
                <el-tag>共需要{{car.CarNum}}辆{{car.DisplayCarModelID}},已分配{{car.CarCount}}辆,剩余{{(car.CarNum||0)-(car.CarCount||0)}}辆</el-tag>
              </div>
            </el-form-item>
            <el-form-item v-else label="已分配吨数" style="width:100%;">
              <el-tag>{{good.YiFenPeiDun_Car||0}}吨</el-tag>
            </el-form-item>
            </p>
            <p v-if="!hiddenInfo" style="margin-bottom: 20px;">
            <el-form-item label="服务态度（满分5分）" style="width:100%;">
              <span>{{good.OrderStatus == '生成订单/配送完成' ? 5 : 0}}</span>
            </el-form-item>
            <el-form-item label="装货时效（满分5分）" style="width:100%;">
              <span>{{good.OrderStatus == '生成订单/配送完成' ? 5 : 0}}</span>
            </el-form-item>
            <el-form-item label="卸货时效（满分5分）" style="width:100%;">
              <span>{{good.OrderStatus == '生成订单/配送完成' ? 4 : 0}}</span>
            </el-form-item>
            <el-form-item label="货损货差（满分5分）" style="width:100%;">
              <span>{{good.OrderStatus == '生成订单/配送完成' ? 5 : 0}}</span>
            </el-form-item>
            </p>
            <el-form-item label="货物图片" style="width:100%"></el-form-item>
            <el-form-item class="imgs" style="width:100%; padding-bottom: 260px;">
              <img @click="previewImage(item)" v-for="item in images" :key="item.AttID" :src="item.Url" alt/>
            </el-form-item>
          </el-form>
          <!--
          <a style='float:right;' href="javascript:;" @click="openCondition">《网络货运电子委托协议》</a>
          -->
        </div>

      </div>
    </div>

    <el-dialog title="电子运单契约条款" :visible.sync="conditionDialogVisible" width="70%" center>
      <condition :id="conditionId" :SourceGoodsNo="good.SourceGoodsNo" :HuoZhu="good.HuoZhu" 
      :CreateTime="good.CreateTime"
      :Description="good.Description"
      :ChuFaDi="good.ChuFaDi"
      :ChuFaDiAddr="good.ChuFaDiAddr"
      :DaoDaDi="good.DaoDaDi"
      :DaoDaDiAddr="good.DaoDaDiAddr"
      :ChuFaRiQi="good.ChuFaRiQi"
      :DaoDaRiQi="good.DaoDaRiQi"
      :GongLiShu="good.GongLiShu"
      :BaoJiaLeiXingName="good.BaoJiaLeiXingName"
      ></condition>
    </el-dialog>

  </div>
</template>
<script>
import condition from "./condition";

export default {
  components: {
    condition
  },
  data() {
    return {
      conditionDialogVisible: false,
      conditionId:null
    }
  },
  props: {
    good: Object,
    images: Array,
    hiddenInfo: Boolean,
    hiddenContract: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    downloadExcel(url) {
      document.getElementById("download_iframe").src = url;
    },
    openCondition() {
      this.conditionId = "0E28FA6A-B7FC-4D8F-97CE-BA966B03B392";
      this.conditionDialogVisible = true;
    },
  },
  mounted() {}
};
</script>
<style>
.tip {
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.el-dialog__body {
  padding-top: 0px !important;
}
.el-table__body .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 65%;
}
.el-table__body .el-form-item__label {
  width: 200px;
  color: #99a9bf;
}
.imgs img {
  width: 30% !important;
  height: 100px !important;
  border-radius: 2px;
  object-fit: cover;
  cursor: pointer;
  margin-left: 5px;
}
.price {
  font-size: 22px !important;
  margin-right: 20px;
}
.el-form-item__content .el-tag {
  float: right;
  margin-top: 2px;
}
</style>





// WEBPACK FOOTER //
// src/components/goodDetail.vue